var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loading)?_c('v-overlay',{attrs:{"z-index":"2000"}},[_c('atom-spinner',{attrs:{"animation-duration":1000,"size":60,"color":"#0153CC"}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }